"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
//import {BannerAd, BannerAdSize, TestIds} from '@react-native-firebase/admob';
const native_base_1 = require("native-base");
const SapporoBannerAd = ({ location, user }) => {
    const [adOK, setAdOk] = (0, react_1.useState)(true);
    //   const adUnitId = __DEV__
    //     ? TestIds.BANNER
    //     : 'ca-app-pub-7867639827150439/8058844455';
    //console.log('Banner Ad Location', location);
    return (react_1.default.createElement(react_1.default.Fragment, null, !(user === null || user === void 0 ? void 0 : user.hideAds) && (react_1.default.createElement(native_base_1.HStack, { safeAreaBottom: true, pt: "0", p: "0" },
        react_1.default.createElement(native_base_1.Center, { w: "95%", flex: 1 })))));
};
exports.default = SapporoBannerAd;
